import { merchantDashboardWidgetIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const removeMerchantDashboardWidget = {
  name: "removeMerchantDashboardWidget" as const,
  input: z.object({ widgetId: merchantDashboardWidgetIdFormat.schema }),
  output: z.object({}),
};
